import React from "react";
import { CopyIcon, IconButton, Toast } from "@sscs/ui";
import { getSharedReportLink } from "../../../../utils";
import styles from "./linksTable.module.scss";

type CopyLinkProps = {
  token: string;
};

const CopyLink = ({ token }: CopyLinkProps): React.JSX.Element => {
  const reportLink = getSharedReportLink(token);

  return (
    <div className={styles["report-link"]}>
      <IconButton
        tooltipTitle="Copy report link"
        onClick={async () => {
          await navigator.clipboard.writeText(reportLink);
          Toast.show({
            title: "Report link copied successfully!",
            type: "success",
          });
        }}
        className={styles["copy-icon"]}
        size="small"
      >
        <CopyIcon />
      </IconButton>
      <a
        href={reportLink}
        target="_blank"
        rel="noreferrer"
        className={styles.link}
      >
        View report
      </a>
    </div>
  );
};

export default CopyLink;
